<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      consultas: [],
      consultasLoading: true,
    };
  },
  methods: {
    getData() {
      this.consultasLoading = true;
      this.consultas = [];

      api
        .get("consultas")
        .then((response) => {
          if (response.data.status == "success" && Array.isArray(response.data.list)) {
            this.consultas = response.data.list;
          } else {
            this.consultas = [];
          }
        })
        .catch(() => {
          this.consultas = [];
        })
        .finally(() => {
          this.consultasLoading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item d-none d-sm-block">Consultas</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Consultas</h3>
        <p></p>
      </div>
    </div>

    <!-- Histórico -->
    <div class="card">
      <div class="card-body">
        <div v-if="consultasLoading" class="consulta-index-skeleton table-responsive" aria-hidden="true">
          <table class="table table-centered table-nowrap mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 56px">
                  <div class="cis-sk-line cis-sk-w-50" style="height: 12px"></div>
                </th>
                <th style="width: 120px">
                  <div class="cis-sk-line cis-sk-w-70" style="height: 12px"></div>
                </th>
                <th>
                  <div class="cis-sk-line cis-sk-w-45" style="height: 12px"></div>
                </th>
                <th style="width: 100px">
                  <div class="cis-sk-line cis-sk-w-80" style="height: 12px"></div>
                </th>
                <th style="width: 140px">
                  <div class="cis-sk-line cis-sk-w-75" style="height: 12px"></div>
                </th>
                <th style="width: 120px">
                  <div class="cis-sk-line cis-sk-w-90" style="height: 12px"></div>
                </th>
                <th class="text-right" style="width: 100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 6" :key="'idx-sk-' + n">
                <td><div class="cis-sk-line cis-sk-w-70" style="height: 14px"></div></td>
                <td><div class="cis-sk-line cis-sk-w-90" style="height: 14px"></div></td>
                <td>
                  <div class="cis-sk-line cis-sk-w-85 mb-1" style="height: 12px"></div>
                  <div class="cis-sk-line cis-sk-w-55" style="height: 10px"></div>
                </td>
                <td><div class="cis-sk-line cis-sk-w-60" style="height: 14px"></div></td>
                <td><div class="cis-sk-line cis-sk-w-95" style="height: 14px"></div></td>
                <td><div class="cis-sk-badge"></div></td>
                <td class="text-right"><div class="cis-sk-pill ml-auto"></div></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-else-if="consultas.length === 0"
          class="min-vh-25 text-center d-flex justify-content-center align-items-center"
        >
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Data</th>
                <th>Serviço</th>
                <th>Documento</th>
                <th>CPF / CNPJ</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in consultas" :key="row.id">
                <td>{{ row.id }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.service_name }}</td>
                <td class="text-uppercase">{{ row.person_type }}</td>
                <td>{{ row.person_number }}</td>
                <td>
                  <span class="badge badge-soft-warning font-size-13" v-if="row.status == 'pending'">PROCESSANDO</span>
                  <span class="badge badge-soft-success font-size-13" v-else-if="row.status == 'completed'">CONCLUÍDA</span>
                  <span class="badge badge-soft-danger font-size-13" v-else-if="row.status == 'error'">ERRO</span>
                </td>
                <td class="text-right">
                  <router-link :to="'/consultas/' + row.id" class="btn btn-default btn-sm btn-rounded">
                    Ver
                    <i class="mdi mdi-arrow-right ml-1"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.consulta-index-skeleton .cis-sk-line,
.consulta-index-skeleton .cis-sk-pill,
.consulta-index-skeleton .cis-sk-badge {
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: consulta-index-skeleton-shimmer 1.4s infinite ease-in-out;
  border-radius: 4px;
}

.consulta-index-skeleton .cis-sk-pill {
  width: 72px;
  height: 31px;
  border-radius: 4px;
}

.consulta-index-skeleton .cis-sk-badge {
  width: 96px;
  height: 22px;
  border-radius: 4px;
}

.consulta-index-skeleton .cis-sk-w-45 {
  width: 45%;
}

.consulta-index-skeleton .cis-sk-w-50 {
  width: 50%;
}

.consulta-index-skeleton .cis-sk-w-55 {
  width: 55%;
}

.consulta-index-skeleton .cis-sk-w-60 {
  width: 60%;
}

.consulta-index-skeleton .cis-sk-w-70 {
  width: 70%;
}

.consulta-index-skeleton .cis-sk-w-75 {
  width: 75%;
}

.consulta-index-skeleton .cis-sk-w-80 {
  width: 80%;
}

.consulta-index-skeleton .cis-sk-w-85 {
  width: 85%;
}

.consulta-index-skeleton .cis-sk-w-90 {
  width: 90%;
}

.consulta-index-skeleton .cis-sk-w-95 {
  width: 95%;
}

@keyframes consulta-index-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

body[data-sidebar="dark"] .consulta-index-skeleton .cis-sk-line,
body[data-sidebar="dark"] .consulta-index-skeleton .cis-sk-pill,
body[data-sidebar="dark"] .consulta-index-skeleton .cis-sk-badge {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.08) 75%
  );
  background-size: 200% 100%;
}
</style>
